import { Link } from "react-router-dom";
import { AuthLayout } from "@/components/ui/auth-layout";
import { Panel } from "@/components/ui/panel";
import { Heading } from "@/components/ui/heading";
import { Text, Muted } from "@/components/ui/text";
import { Button } from "@/components/ui/button";

export default function MaintenanceRestrictedRoute() {
  return (
    <AuthLayout>
      <Panel padding="lg" className="space-y-6">
        {/* Logo */}
        <div className="flex justify-center">
          <img src="/logo-inverted-20260129.svg" alt="Rollforward" className="h-12 w-auto" />
        </div>

        {/* Content */}
        <div className="text-center space-y-4">
          <Heading size="lg">Access Restricted</Heading>
          <Text>
            This testing environment is currently restricted to authorized users only. Access is
            limited to @rollforward.com email addresses.
          </Text>
        </div>

        {/* Support info */}
        <div className="rounded-lg bg-muted p-4 text-center">
          <Muted>
            If you believe you should have access, please contact your administrator or support at{" "}
            <a
              href="mailto:support@rollforward.com"
              className="text-foreground underline hover:no-underline"
            >
              support@rollforward.com
            </a>
          </Muted>
        </div>

        {/* Action */}
        <div className="flex justify-center">
          <Button variant="secondary" asChild>
            <Link to="/login">Back to Login</Link>
          </Button>
        </div>
      </Panel>
    </AuthLayout>
  );
}
